import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  accordionItem: {
    marginBottom: theme.spacing(1.5),
  },
  accordionSummary: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    width: '100%',
  },
  metadataBox: {
    marginBottom: theme.spacing(2),
  },
  metadataText: {
    fontWeight: 600,
  },
  jsonBox: {
    marginTop: theme.spacing(2),
  },
  jsonLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  jsonPreBox: {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.grey[900]
      : theme.palette.grey[100],
    color: theme.palette.mode === 'dark'
      ? theme.palette.grey[100]
      : theme.palette.grey[900],
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    overflow: 'auto',
    fontSize: '0.75rem',
    fontFamily: 'monospace',
    border: `1px solid ${theme.palette.divider}`,
    maxHeight: 400,
  },
}));

const WrapperApiSourceResponseCard = ({ sourceResponse, classes: dialogClasses }) => {
  const classes = useStyles();
  
  if (!sourceResponse) return null;

  const sourceResponses = sourceResponse;
  
  if (!Array.isArray(sourceResponses) || sourceResponses.length === 0) return null;

  return (
    <Card variant="outlined" className={classes.card}>
      <CardHeader
        title="Source Response(s)"
        avatar={<ArrowBackIcon />}
        className={dialogClasses.logSearchDialogHeader}
      />
      <CardContent>
        <Box>
          {sourceResponses.map((response, rIdx) => (
            <Accordion key={rIdx} className={classes.accordionItem}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box className={classes.accordionSummary}>
                  <Typography variant="subtitle2" className={classes.metadataText}>
                    Response {rIdx + 1}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails style={{ display: 'block' }}>
                {/* Metadata Row */}
                <Box className={classes.metadataBox}>
                  <Typography variant="subtitle2" className={classes.metadataText}>
                    <strong>Priority:</strong> {response.priority || response.Priority || 'N/A'}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.metadataText}>
                    <strong>URL:</strong> {response.url || response.URL || 'N/A'}
                  </Typography>
                </Box>

                {/* JSON Response Data */}
                {(response.dataJson || response.DataJson) && (
                  <Box className={classes.jsonBox}>
                    <Typography variant="subtitle2" className={classes.jsonLabel}>
                      <strong>Response Data (JSON):</strong>
                    </Typography>
                    <Box
                      component="pre"
                      className={classes.jsonPreBox}
                    >
                      {JSON.stringify(response.dataJson || response.DataJson, null, 2)}
                    </Box>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

WrapperApiSourceResponseCard.propTypes = {
  sourceResponse: PropTypes.array,
  classes: PropTypes.object.isRequired,
};

export default WrapperApiSourceResponseCard;
